import { Button } from "@mui/material";
import { Assessment } from "@mui/icons-material";

import UserTransmissionProgressReportModal from "./modals/UserTransmissionProgressReportModal";
import useUserTransmissionProgressReport from "./hooks/useUserTransmissionProgressReport";

const UserTransmissionProgressReport = () => {
  const { showUserTransmissionReportModal, openModal, closeModal } =
    useUserTransmissionProgressReport();

  return (
    <>
      <div className="d-flex flex-end ">
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            openModal();
          }}
          startIcon={<Assessment />}
        >
          User Transmission Progress Report
        </Button>
      </div>

      {showUserTransmissionReportModal && (
        <UserTransmissionProgressReportModal onClose={closeModal} />
      )}
    </>
  );
};

export default UserTransmissionProgressReport;
